import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import './plugins/bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import App from './App.vue'
import router from './router'
import store from './store'
import '@fortawesome/fontawesome-free/css/all.css'
import AOS from 'aos'
import 'aos/dist/aos.css'
import './assets/styles/styles.css'

import { BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'


Vue.config.productionTip = false

import formatDate from './filters/format-date'
Vue.use(formatDate)

import swal from '@/plugins/swal'
Vue.use(swal)

import numbers from "./filters/numbers"
Vue.use(numbers)


import msg from '@/plugins/msg'
Vue.use(msg)


import { BCalendar } from 'bootstrap-vue'
Vue.component('b-calendar', BCalendar)




import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(BootstrapVueIcons)
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBySfJg_N6hj9O_FvUkm5sOSVO72w2MrIw",
    libraries: 'places',
  },
});

new Vue({
  data: {
    idCliente: 0,
    nombreCliente: '',
    estacion:'',
    direccionEstacion:'',
    folioPago: '',
    tipoReporte:'',
    empresa:0
  },
  router,
  store,
  render: h => h(App),
  mounted () {
    if (localStorage.idCliente){
      this.idCliente = localStorage.idCliente;
    }
    if (localStorage.nombreCliente){
      this.nombreCliente = localStorage.nombreCliente;
    }
    if (localStorage.estacion){
      this.estacion = localStorage.estacion;
    }
    if (localStorage.direccionEstacion){
      this.direccionEstacion = localStorage.direccionEstacion;
    }
    if (localStorage.folioPago){
      this.folioPago = localStorage.folioPago;
    }
    if (localStorage.tipoReporte){
      this.tipoReporte = localStorage.tipoReporte;
    }
    if (localStorage.empresa){
      this.empresa = localStorage.empresa;
    }

    AOS.init()},
    methods: {
      persist() {
        localStorage.idCliente =  this.idCliente;
        localStorage.nombreCliente = this.nombreCliente
        localStorage.estacion = this.estacion
        localStorage.direccionEstacion = this.direccionEstacion
        localStorage.folioPago = this.folioPago
        localStorage.tipoReporte = this.tipoReporte
        localStorage.empresa = this.empresa
      }
    },
}).$mount('#app')
